import { Pipe, PipeTransform } from '@angular/core';
import { TranslationLoaderService } from '../translation/translation-loader.service';
import * as moment from 'moment/moment';
import * as momentTimezone from 'moment-timezone/builds/moment-timezone-with-data';

@Pipe({ name: 'sumtDate' })
export class SumtDatePipe implements PipeTransform {
    private currentCulture: string;
    constructor(private translationLoaderService: TranslationLoaderService) {
        this.currentCulture = this.translationLoaderService.getCurrentCulture();
    }
    transform(value: any , isDateTime: boolean = false , isDateOnly: boolean = false, isTimeOnly: boolean = false,
        dateFormatStr: string, timeFormatStr: string ) {
        const tzone = momentTimezone.tz.guess();
        const localeData = moment.localeData();
        const localeDateFormat = localeData.longDateFormat('L');
        const localeTimeFormat = localeData.longDateFormat('LT') + ' zz';

        const dateFormat = dateFormatStr || localeDateFormat;
        const timeFormat = timeFormatStr || localeTimeFormat;

        if (isDateTime) {
        return momentTimezone.utc(value).tz(tzone).format(dateFormat + ' ' + timeFormat);
        } else if (isTimeOnly) {
         return momentTimezone.utc(value).tz(tzone).format(timeFormat);
        } else if (isDateOnly) {
        return momentTimezone.utc(value).tz(tzone).format(dateFormat);
        }
  }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/pipes/sumt-date.pipe.ts